import { combineReducers } from 'redux';
import { Map } from 'immutable';
import data from './data/reducer';
import core from './core';

const MIDDLEWARE_INITIAL_STATE = new Map({
    general: new Map({ state: null }),
});

function middleware(env, state = MIDDLEWARE_INITIAL_STATE, action) {
    switch (action.type) {
        case `${env.toUpperCase()}__MIDDLEWARE_SET_CONNEXION_STATE`:
            return core.setMiddlewareConnectionState(state, action.state);
    }
    return state;
}

const GROUPID_INITIAL_STATE = new Map({
    clientInterface: null,
    groupId: null,
    assigneeIds: null,
});

function gitlabApi(env, state = GROUPID_INITIAL_STATE, action) {
    switch (action.type) {
        case `${env.toUpperCase()}_GIT__SET_GROUPID`:
            return core.setGroupId(state, action.groupId);
        case `${env.toUpperCase()}_GIT__SET_ASSIGNEEIDS`:
            return core.setAssigneeIds(state, action.assigneeIds);
        case `${env.toUpperCase()}_SET_CLIENTINTERFACE`:
            return core.setClientInterface(state, action.clientInterface);
    }
    return state;
}
function config(env, state = new Map(), action) {
    switch (action.type) {
        case `${env.toUpperCase()}_SET_CONFIG`:
            return core.setConfig(state, action.config);
    }
    return state;
}
function enums(env, state = {}, action) {
    switch (action.type) {
        case `${env.toUpperCase()}_SET_ENUMS`:
            return core.setEnums(state, action.enums);
    }
    return state;
}

export default env => {
    return combineReducers({
        config: (...props) => config(env, ...props),
        gitlabApi: (...props) => gitlabApi(env, ...props),
        middleware: (...props) => middleware(env, ...props),
        data: (...props) => data(env)(...props),
        enums: (...props) => enums(env, ...props),
    });
};



// WEBPACK FOOTER //
// ./environments/genericEnv/reducer.js